import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PosIntegrationService } from '../../../../../../services/pos-integration.service';
import { HelpersService } from '../../../../../../services/helpers.service';
import { PartnerService } from '../../../../../../services/partner.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lightspeed-defaults',
  templateUrl: './lightspeed-defaults.component.html',
  styleUrls: ['./lightspeed-defaults.component.scss'],
  providers: [MessageService],
})
export class LightspeedDefaultsComponent implements OnInit {
  @Input() partner;
  @Output() status = new EventEmitter();
  public partnerID;
  public busy = true;
  public busyTechnicians = false;
  public config: any = {};
  public registers: any = [];
  public taxes: any = [];
  public users: any = [];
  public shops: any = [];
  public vendors: any = [];
  public paymentTypes: any = [];
  public isWizard: boolean = false;
  public canDoQBPSearch: boolean = false;
  public canDoHLCSearch: boolean = false;
  public canDoJBISearch: boolean = false;
  public technicians: any = [];
  public isWorkshop = true;
  public isRentals = false;

  constructor(
    private posIntegrationService: PosIntegrationService,
    private messageService: MessageService,
    private translate: TranslateService,
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    private router: Router,
  ) {
    if (this.router.url.indexOf('bikeshop-wizard') > -1) {
      this.isWizard = true;
    }
  }

  ngOnInit() {
    if (
      this.router.url.toLocaleLowerCase() ===
      '/store/rentals/pos-integrations'
    ) {
      this.isRentals = true;
      this.isWorkshop = false;
    }
    this.partnerID = this.partner.ID || this.partner.PartnerID;
    var partner = this.helpersService.getPartnerData();

    //this.canDoExternalSearch = partner.POSSystemID === 6 && partner.ExternalProductIntegrationsPartnerLinks && partner.ExternalProductIntegrationsPartnerLinks.length > 0;
    this.canDoQBPSearch =
      partner.POSSystemID === 6 &&
      partner.ExternalProductIntegrationsPartnerLinks &&
      partner.ExternalProductIntegrationsPartnerLinks.filter((x) => {
        return (
          x.ExternalProductPartnerID === 1 || x.ExternalProductPartnerID === 2
        );
      }).length > 0;
    this.canDoHLCSearch =
      partner.POSSystemID === 6 &&
      partner.ExternalProductIntegrationsPartnerLinks &&
      partner.ExternalProductIntegrationsPartnerLinks.filter((x) => {
        return (
          x.ExternalProductPartnerID === 3 || x.ExternalProductPartnerID === 4
        );
      }).length > 0;
    this.canDoJBISearch =
      partner.POSSystemID === 6 &&
      partner.ExternalProductIntegrationsPartnerLinks &&
      partner.ExternalProductIntegrationsPartnerLinks.filter((x) => {
        return x.ExternalProductPartnerID === 5;
      }).length > 0;

    this.getRegisters();
    this.getTaxes();
    this.getUsers();
    this.getShops();
    this.getPaymentTypes();
    this.getVendors();
    this.getConfig();
    this.getTechnicians();
  }

  getTechnicians() {
    this.partnerService
      .getPartnerTechnicians(this.helpersService.getPartnerId())
      .subscribe((technicians) => {
        this.technicians = technicians
          .filter((x) => {
            return x.IsActive === true;
          })
          .map((x) => {
            return {
              ...x,
              POSEmployeeID: x.POSEmployeeID ? parseInt(x.POSEmployeeID) : null,
            };
          });
      });
  }

  getConfig() {
    this.posIntegrationService.getLightSpeedConfig(this.partnerID).subscribe(
      (res) => {
        this.config = res;
        this.busy = false;
      },
      (err) => {
        this.busy = false;
      },
    );
  }

  getRegisters() {
    this.posIntegrationService
      .getLightspeedRegisters(this.partnerID)
      .subscribe((res) => {
        this.registers = res.map((x) => {
          return { label: x.Description, value: x.ID };
        });
      });
  }

  getTaxes() {
    this.posIntegrationService
      .getLightspeedTaxes(this.partnerID)
      .subscribe((res) => {
        this.taxes = res.map((x) => {
          return { label: x.Description, value: x.ID };
        });
      });
  }

  getUsers() {
    this.posIntegrationService
      .getLightspeedUsers(this.partnerID)
      .subscribe((res) => {
        this.users = res.map((x) => {
          return { label: x.Description, value: x.ID };
        });
      });
  }

  getShops() {
    this.posIntegrationService
      .getLightspeedShops(this.partnerID)
      .subscribe((res) => {
        this.shops = res.map((x) => {
          return { label: x.Description, value: x.ID };
        });
      });
  }

  getPaymentTypes() {
    this.posIntegrationService
      .getLightspeedPaymentTypes(this.partnerID)
      .subscribe((res) => {
        this.paymentTypes = res.map((x) => {
          return { label: x.Description, value: x.ID };
        });
      });
  }

  getVendors() {
    this.posIntegrationService
      .getLightspeedVendors(this.partnerID)
      .subscribe((res) => {
        this.vendors = res
          .map((x) => {
            return { label: x.Description, value: x.ID };
          })
          .sort((x, y) => {
            if (x.label > y.label) return 1;
            if (x.label < y.label) return -1;
            return 0;
          });
      });
  }

  updateConfig() {
    this.busy = true;
    this.config.ID = this.partnerID;
    this.posIntegrationService.updateLightspeedConfig(this.config).subscribe(
      (result) => {
        this.busy = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant('onboarding.pos_settings_updated'),
        });
        // this.posIntegrationService.startFullPOSSync(this.partnerID).subscribe(sync=>{},err=>{});
        // this.posIntegrationService.startPOSClientSync(this.partnerID).subscribe(sync=>{},err=>{});
        this.status.emit({ configurationSaved: true });
        this.partnerService.getPartnerDetail(this.partnerID).subscribe(partner=>{
          this.helpersService.savePartnerData(partner);
        });
      },
      (err) => {
        this.busy = false;
      },
    );
  }

  updateTechnicians() {
    this.busyTechnicians = true;
    this.partnerService
      .updateTechnicianPOSEmployee(
        this.partnerID,
        this.technicians.map((x) => {
          return { TechnicianID: x.ID, POSEmployeeID: x.POSEmployeeID };
        }),
      )
      .subscribe((result) => {
        this.busyTechnicians = false;
      });
  }
}
